import { render, staticRenderFns } from "./regalo.vue?vue&type=template&id=36d525ff"
import script from "./regalo.vue?vue&type=script&lang=ts"
export * from "./regalo.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports